<div class="p-grid contentContainer">
  <div class="p-col-12">
    <!-- routes will be rendered here -->
    <app-http-alert></app-http-alert>
    <router-outlet></router-outlet>

    <app-cart-handle></app-cart-handle>
  </div>

</div>

